export enum FieldTypes {
  TEAMS = "TEAMS",
  SERIES = "SERIES",
  TAGS = "TAGS",
}

export enum FieldTypesSingular {
  TEAMS = "TEAM",
  SERIES = "SERIES",
  TAGS = "TAG",
}
